// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__M4ejA","content":"styles_content__37oha","checkbox":"styles_checkbox__IKXpJ","checkboxLabel":"styles_checkboxLabel__2lJUG"};